module.exports = __webpack_public_path__ + "img/AGO.7f85e01b.svg";